<h1 class="table__title">Linked Documents</h1>
<div class="table__control">
  <button *ngIf="addButton" mat-raised-button class="grey-btn" (click)="selectLinkedDocuments($event)">
    <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
    Link Document
  </button>
</div>
<ng-template #noDocs>
  <h4>No Linked Documents</h4>
</ng-template>
<div class="table__container">

  <table *ngIf="documents?.length > 0;else noDocs" class="table__inner" mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="Action" *ngIf="addButton">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element"><a matTooltip="Delete Linked Document" (click)="delete(element)">
          <mat-icon>delete</mat-icon>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ContractIdentifier">
      <th mat-header-cell *matHeaderCellDef>Contract Identifier</th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="!element?.noAccess" target="_blank"
          [routerLink]="['../..','DocumentView',element.id]">{{ element?.propertiesObj.ContractIdentifier }}</a>
        <span *ngIf="element?.noAccess">{{ element?.propertiesObj.ContractIdentifier }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.DocumentTitle }}</td>
    </ng-container>

    <ng-container matColumnDef="FoldersFiledIn">
      <th mat-header-cell *matHeaderCellDef>Location</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.FoldersFiledIn }}</td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div class="table__pagination">
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
